/*eslint no-array-constructor: "off"*/
/*eslint react-hooks/exhaustive-deps: "off"*/
import { consumirServicioEncirptacion } from 'api';
import imgBreadcrumb from 'assets/img/mex/travelBta/imgBreadcrum.png';
import BreadCurmb from 'components/BreadCrumbMex/BreadCrumb';
import BreadCurmbPasos from 'components/BreadCrumbMex/BreadCrumbTipo2';
import MisDatosForm from 'components/MisDatosForm';
import Page from 'components/Page';
import {
  ambienteAplicacion,
  urlActualizarCotitzacionAP,
  urlCatalogosCotizadorMex,
} from 'constants/urls';
import { useNavbarContext } from 'contexts/NavbarContext';
import React, { useEffect, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { setContratante } from 'redux/actions/cotizacion.actions';
import { FetchIdCotizacionActual } from 'redux/actionsMex/aCarrito';
import useParametrosPago from 'redux/hooks/useParametrosPago';
import { PASOS_BREADCRUMBS, PRODUCTOS } from 'utils/constants';
import Loading from 'wrappers/Loading';

const pasos = [
  {
    title: '1. Datos personales',
    active: true,
  },
  {
    title: '2. Elige el plan',
  },
  {
    title: '3. Opción de pago',
  },
  {
    title: '4. Confirma tu compra',
  },
];

const ContainerIngresoDatosTBTA = ({
  history,
  params: { idCotizacion },
  dataUsuario,
  dispatch,
}) => {
  useNavbarContext(PRODUCTOS.TRAVELBTA);
  const [loading, setLoading] = useState(true);
  const [loadingText, setLoadingText] = useState('Cargando...');
  const [catalogo, setCatalogo] = useState(null);
  const methods = useForm({ mode: 'onChange' });
  const { cliCodigoCore } = dataUsuario;

  const { fetchParametros } = useParametrosPago(PRODUCTOS.TRAVELBTA);

  const getData = async () => {
    setLoading(true);
    const Data = {
      datosCotizador: {
        prodCodigo: PRODUCTOS.TRAVELBTA,
        cotPasoCodigo: 'terminosCondiciones',
        usuCotiza: {
          usuCodigo: cliCodigoCore || '',
        },
      },
    };
    const res = await consumirServicioEncirptacion(urlCatalogosCotizadorMex, Data);
    console.log('CATALOGO: ', res);
    if (res.transaccion) {
      res.catalogo.inputs.push({
        input: 'disclaimerTerminos',
        href: res.catalogo.urlTerminosCondiciones,
      });

      setCatalogo(res.catalogo);
    }

    setLoading(false);
  };

  useEffect(() => {
    getData();
    fetchParametros();
  }, []);

  const onSubmit = async (data) => {
    setLoading(true);
    setLoadingText('Gracias por enviar sus datos, espere por favor...');
    const Data = {
      ambiente: ambienteAplicacion,
      prodCodigo: PRODUCTOS.TRAVELBTA,
      pasoCodigo: 'informacionCliente',
      items: {
        usuCotiza: {
          usuCodigo: cliCodigoCore || '',
        },
        cotCodigo: idCotizacion || '',
        ...data,
      },
    };

    const res = await consumirServicioEncirptacion(urlActualizarCotitzacionAP, Data);
    console.log('RES: ', res);
    if (res.transaccion) {
      dispatch(
        setContratante({ cotizador: PRODUCTOS.TRAVELBTA, data: data.datosCliente }),
      );
      let cotActual = { cotizador: PRODUCTOS.TRAVELBTA, id: res.id };
      dispatch(FetchIdCotizacionActual(cotActual));
      history.push(`/travel-empresas-planes`);
    }
    setLoading(false);
    setLoadingText('Cargando...');
  };

  return (
    <React.Fragment>
      <Loading loading={loading} message={loadingText}>
        <div className="cr-content">
          <Page>
            <BreadCurmb {...PASOS_BREADCRUMBS[PRODUCTOS.TRAVELBTA].breadCrumb} />

            <BreadCurmbPasos
              title="Cotiza tu seguro de viajes"
              subtitle="Necesitamos saber esta breve información para ofrecerte una cotización personalizada."
              pasos={pasos}
              img={imgBreadcrumb}
            />

            <FormProvider {...methods}>
              <form onSubmit={methods.handleSubmit(onSubmit)}>
                <div className="row justify-content-center">
                  <div className="col-11 col-md-6 col-xl-4">
                    <MisDatosForm
                      methods={methods}
                      inputs={[
                        'usuCorreo',
                        'usuContratante',
                        'usuRFC',
                        'usuNombre',
                        'usuTelefono',
                        'disclaimerTerminos',
                      ]}
                      overrideInputs={catalogo && catalogo.inputs}
                      clavesAgente={catalogo?.permisos?.agentes}
                    />
                  </div>
                </div>
              </form>
            </FormProvider>
          </Page>
        </div>
      </Loading>
    </React.Fragment>
  );
};

export default ContainerIngresoDatosTBTA;
